import { z } from "zod";

export const ExperienceAnalysisQueryTemplateTypeList = [
  "summary",
  "custom",
  "testNext",
] as const;
export type ExperienceAnalysisQueryTemplateType =
  (typeof ExperienceAnalysisQueryTemplateTypeList)[number];

export const OpenAiRoleList = ["user", "assistant"] as const;
export type OpenAiRoleType = (typeof OpenAiRoleList)[number];

export const OpenAiMessageSchema = z.object({
  id: z.string(),
  message: z.string(),
  role: z.enum(OpenAiRoleList),
  fileId: z.string().optional(),
  fileUrl: z.string().optional(),
});
export type OpenAiMessage = z.infer<typeof OpenAiMessageSchema>;

export const ExperienceAnalysisHistoryDtoSchema = z.object({
  threadId: z.string(),
  assistantId: z.string(),
  title: z.string(),
  messages: OpenAiMessageSchema.array(),
  createdAt: z.number(),
});

export type ExperienceAnalysisHistoryDto = z.infer<
  typeof ExperienceAnalysisHistoryDtoSchema
>;
